import { createContext, useState, type ReactNode, useEffect } from 'react';
import type { AuthContextProps, User } from '../types';
import { getJSONItem, setItem } from '../../shared/services/storage/storage';
import { STORAGE_KEY } from '../../shared/config';

export const AuthB2cContext = createContext<AuthContextProps | null>(null);

export const AuthB2cProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(getJSONItem(STORAGE_KEY.B2C_USER));

  const providerValue = {
    user,
    setUser,
  };

  useEffect(() => {
    setItem(STORAGE_KEY.B2C_USER, user);
  }, [user]);

  return <AuthB2cContext.Provider value={providerValue}>{children}</AuthB2cContext.Provider>;
};
